import { DataHeader, DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDivisionCode extends Layout {
    dataheaderDivisionCode: DataHeader;
    sourceDivisionLookup: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
